import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
import VueCookies from 'vue-cookies'

//引入列表滚动插件
import vueSeamlessScroll from 'vue-seamless-scroll' // 循环滚动

import animated from 'animate.css'
//引入自定义指令
import num from '@/utils/num';
import hasPermi from '@/utils/hasPermi';

// 引入全局css
import './assets/scss/style.scss';
import './assets/scss/animation.scss';
// 自动适配支持
import 'lib-flexible-computer';

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';


//引入echart
//4.x 引用方式
import echarts from 'echarts'
import 'echarts-liquidfill';
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(vueSeamlessScroll)

// 全局注册
Vue.component('icon', Icon);
Vue.use(dataV);
Vue.use(animated);

//注册指令
Vue.directive("numchange", num);
Vue.directive("permi", hasPermi);

//数据请求

import api from './api/api.js'
Vue.prototype.$api = api;

//引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');